import React from "react";

// Error boundary to catch react-markdown crashes from malformed HTML content
class MarkdownErrorBoundary extends React.Component<
  { children: React.ReactNode; fallbackContent: string },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode; fallbackContent: string }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error("[MarkdownErrorBoundary] Markdown rendering failed:", error.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        <pre className="al-text-sm al-text-gray-700 al-whitespace-pre-wrap al-break-words al-font-mono al-m-0">
          {this.props.fallbackContent}
        </pre>
      );
    }
    return this.props.children;
  }
}

export default MarkdownErrorBoundary;
